export const NUMBER_OF_CLASSES_PER_TERM: number = 9

export const NUMBER_OF_ENROLMENTS_PER_CLASS_PER_CAMPUS: any = {
  "C": 15,
  "E": 15,
  "M": 15,
  "S": 14,
  "T": 15,
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/constants/matrix_classes.ts